import { render } from "./LoupeIcon.vue?vue&type=template&id=6365460e"
import script from "./LoupeIcon.vue?vue&type=script&lang=js"
export * from "./LoupeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__